import getEnviroment from '../utils/getEnviroment';

interface ApiProps {
  [api: string]: {
    [enviroment: string]: string;
  };
}

const API: ApiProps = {
  'api-contribua': {
    develop: 'https://api-contribua-develop.rj.r.appspot.com',
    production: 'https://api-contribua-production.rj.r.appspot.com',
  },
  'api-enderecos': {
    develop: 'https://api-enderecos-develop.rj.r.appspot.com',
    production: 'https://api-enderecos-production.rj.r.appspot.com',
  },
  'api-pessoas': {
    develop: 'https://api-pessoas-develop.rj.r.appspot.com',
    production: 'https://api-pessoas-production.rj.r.appspot.com',
  },
  'api-mock': {
    local: 'https://run.mocky.io/v3/',
    develop: 'https://run.mocky.io/v3/',
  },
};

export default function getUrlApi(api: string) {
  const enviroment = getEnviroment();

  return API[api][enviroment];
}
